import React from "react";
import { motion } from "framer-motion";

export function AnimatedLogo({ className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      <motion.svg
        id="Layer_2"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 380.96 71.35"
        className="w-full h-full"
      >
        <defs>
          <style>
            {`
              .cls-1 {
                fill: url(#linear-gradient);
              }

              .cls-1, .cls-2, .cls-3 {
                stroke-width: 0px;
              }

              .cls-2 {
                fill: #009da6;
              }

              .cls-3 {
                fill: #353535;
              }
            `}
          </style>
          <linearGradient
            id="linear-gradient"
            x1="113.87"
            y1="35.68"
            x2="380.96"
            y2="35.68"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#91c650" />
            <stop offset="1" stopColor="#009da6" />
          </linearGradient>
        </defs>
        <g id="Layer_1-2" data-name="Layer 1">
          <g>
            <g>
              <motion.path
                className="cls-1"
                d="M134.44,71.35h-12.96c1.17-20.18,30.55-30.31,48.05-34.28l-5.59-5.34h-50.08v-15.53L130.08,0h49.93l23.5,23.5,11.3-11.3,3.93,1.76c45.18,20.25,85.13,19.27,110.68,14.88,27.82-4.77,45.17-14.51,45.34-14.61l6.2,10.84c-.76.44-19.04,10.76-48.85,15.97-26.64,4.65-67.85,5.88-114.52-13.97l-14.07,14.08-28.67-28.67h-39.59l-6.76,6.76h40.46l27.34,26.12-12.79,1.78c-15.83,2.21-48.28,10.84-49.06,24.21Z"
                initial={{ pathLength: 0, opacity: 0 }}
                animate={{ pathLength: 1, opacity: 1 }}
                transition={{
                  duration: 2.5,
                  ease: [0.22, 1, 0.36, 1],
                  opacity: { duration: 0.5, delay: 0.2 },
                }}
              />
              <motion.circle
                className="cls-2"
                cx="355.3"
                cy="9.44"
                r="5.33"
                initial={{ scale: 0, opacity: 0 }}
                animate={{
                  scale: [0, 1.2, 1],
                  opacity: [0, 1, 1],
                }}
                transition={{
                  delay: 1.2,
                  duration: 0.6,
                  ease: [0.34, 1.56, 0.64, 1],
                }}
              />
              <motion.circle
                className="cls-2"
                cx="218.13"
                cy="51.53"
                r="5.33"
                initial={{ scale: 0, opacity: 0 }}
                animate={{
                  scale: [0, 1.2, 1],
                  opacity: [0, 1, 1],
                }}
                transition={{
                  delay: 1.5,
                  duration: 0.6,
                  ease: [0.34, 1.56, 0.64, 1],
                }}
              />
              <motion.circle
                className="cls-2"
                cx="218.13"
                cy="66.02"
                r="5.33"
                initial={{ scale: 0, opacity: 0 }}
                animate={{
                  scale: [0, 1.2, 1],
                  opacity: [0, 1, 1],
                }}
                transition={{
                  delay: 1.8,
                  duration: 0.6,
                  ease: [0.34, 1.56, 0.64, 1],
                }}
              />
              <motion.circle
                className="cls-2"
                cx="153.28"
                cy="66.02"
                r="5.33"
                initial={{ scale: 0, opacity: 0 }}
                animate={{
                  scale: [0, 1.2, 1],
                  opacity: [0, 1, 1],
                }}
                transition={{
                  delay: 2.1,
                  duration: 0.6,
                  ease: [0.34, 1.56, 0.64, 1],
                }}
              />
            </g>
            <g>
              <motion.path
                className="cls-3"
                d="M14.16,32.13c.48-.48.72-1.07.72-1.77s-.25-1.25-.74-1.73c-.49-.48-1.07-.72-1.75-.72s-1.25.24-1.73.72c-.5.48-.76,1.06-.76,1.73s.24,1.28.72,1.77c.48.48,1.07.72,1.77.72s1.28-.24,1.77-.72Z"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.3, duration: 0.5 }}
              />
              <motion.path
                className="cls-3"
                d="M47.69,31.99c.48-.48.72-1.04.72-1.69s-.24-1.21-.72-1.68c-.48-.47-1.03-.7-1.66-.7-.67,0-1.24.23-1.69.7-.46.47-.68,1.03-.68,1.68s.23,1.21.7,1.69c.47.48,1.03.72,1.67.72s1.18-.24,1.66-.72Z"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.4, duration: 0.5 }}
              />
              <motion.path
                className="cls-3"
                d="M41.32,31.99c.46-.48.68-1.04.68-1.69s-.23-1.21-.7-1.68c-.47-.47-1.03-.7-1.68-.7s-1.24.24-1.69.72c-.46.46-.68,1.01-.68,1.66s.23,1.21.7,1.69,1.03.72,1.67.72,1.21-.24,1.69-.72Z"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.5, duration: 0.5 }}
              />
              <motion.path
                className="cls-3"
                d="M85.23,5.41c.67,0,1.26-.24,1.77-.72.48-.48.72-1.07.72-1.77s-.25-1.28-.74-1.76c-.49-.48-1.08-.72-1.75-.72s-1.26.24-1.75.72c-.49.48-.74,1.07-.74,1.76s.25,1.28.74,1.77c.49.48,1.07.72,1.75.72Z"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.6, duration: 0.5 }}
              />
              <motion.path
                className="cls-3"
                d="M83.25,17.87c0,2.11-.83,3.17-2.49,3.17h-1.19c-.84,0-1.48-.28-1.91-.85-.43-.56-.65-1.34-.65-2.32V7.21h-4.18v10.27c0,1.1-.28,1.98-.83,2.61-.55.64-1.25.95-2.09.95s-1.54-.32-2.09-.95c-.55-.64-.83-1.51-.83-2.61v-6.5h-4.18v6.5c0,1.1-.28,1.98-.83,2.61-.55.64-1.25.95-2.09.95s-1.57-.31-2.11-.94-.81-1.5-.81-2.63v-6.43h-4.21v6.83c0,2.11-.84,3.17-2.52,3.17h-2.81c-.84,0-1.48-.28-1.91-.85-.43-.56-.65-1.34-.65-2.32v-6.89h-4.18v6.89c0,.98-.22,1.76-.65,2.32-.43.56-1.06.85-1.87.85h-17.98v-2.27c-.02-3.39-1.15-6.16-3.39-8.32-2.23-2.16-5.02-3.24-8.36-3.24H0v4.18h8.25c2.35,0,4.23.68,5.62,2.04,1.39,1.36,2.1,3.2,2.13,5.53l.04,2.09h-7.35c-2.52,0-4.6.72-6.23,2.16-1.63,1.44-2.45,3.23-2.45,5.37,0,2.5,1.04,4.57,3.13,6.23l1-1.29c.78-1.01.84-2.34.35-3.51-.18-.44-.27-.91-.27-1.43,0-.98.4-1.79,1.19-2.41.79-.63,1.91-.94,3.35-.94h29.43c1.99,0,3.53-.77,4.61-2.31,1.08,1.54,2.63,2.31,4.65,2.31h2.81c2.16,0,3.73-.83,4.72-2.49,1.1,1.66,2.75,2.49,4.94,2.49s3.9-.9,5.01-2.7c1.1,1.8,2.77,2.7,5.01,2.7,2.11,0,3.76-.83,4.94-2.49.98,1.66,2.56,2.49,4.72,2.49h1.19c2.02,0,3.64-.68,4.86-2.04,1.22-1.36,1.84-3.13,1.84-5.31V7.21h-4.21v10.66Z"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.7, duration: 0.5 }}
              />
              <motion.path
                className="cls-3"
                d="M9.43,46.85c-1.26,0-2.36.3-3.3.91-.94.61-1.69,1.39-2.22,2.36l.02-3.27H0v18.8h4.01v-9.43c0-1.8.41-3.15,1.25-4.06.83-.91,1.89-1.37,3.17-1.37s2.34.46,3.17,1.37,1.25,2.26,1.25,4.06v9.43h4.01v-9.43c0-3.1-.67-5.44-2.02-7.01s-3.15-2.36-5.39-2.36Z"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.8, duration: 0.5 }}
              />
              <motion.path
                className="cls-3"
                d="M31.94,55.09c-1.1-.37-2.2-.67-3.3-.91-1.1-.24-2.03-.51-2.8-.83-.76-.31-1.15-.72-1.15-1.21,0-.54.29-.97.88-1.28s1.36-.47,2.32-.47,1.85.16,2.8.47c.94.31,1.69.79,2.22,1.42l2.43-2.43c-1.73-2.04-4.25-3.07-7.55-3.07-2.13,0-3.85.49-5.16,1.48-1.3.99-1.95,2.28-1.95,3.87,0,1.3.38,2.38,1.15,3.22.76.84,1.7,1.44,2.8,1.8,1.1.36,2.2.66,3.29.89,1.09.24,2.02.52,2.78.86.76.34,1.15.79,1.15,1.35,0,.65-.31,1.15-.93,1.5-.62.35-1.45.52-2.51.52s-2.11-.19-3.15-.57c-.42-.15-.8-.33-1.15-.52-.87-.48-1.95-.4-2.67.29l-1.39,1.34c1.01,1.08,2.27,1.89,3.79,2.43,1.52.54,3.04.81,4.57.81,2.13,0,3.91-.5,5.34-1.5,1.43-1,2.14-2.46,2.14-4.4,0-1.3-.38-2.38-1.15-3.23-.76-.85-1.7-1.47-2.8-1.84Z"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.9, duration: 0.5 }}
              />
              <motion.path
                className="cls-3"
                d="M47.88,46.88c-2.61,0-4.83.93-6.67,2.8-1.84,1.86-2.76,4.1-2.76,6.7s.99,4.92,2.77,6.7c1.9,1.89,4.26,2.84,7.1,2.84,1.55,0,3.06-.34,4.52-1.01,1.46-.67,2.63-1.58,3.5-2.73l-1.26-.79c-1.06-.67-2.38-.61-3.47,0-.94.53-2.04.79-3.29.79-1.39,0-2.61-.39-3.64-1.16-1.03-.78-1.67-1.75-1.92-2.91h14.45c.07-1.08.1-1.65.1-1.72,0-2.63-.91-4.87-2.73-6.72s-4.05-2.78-6.71-2.78ZM42.76,54.87c.11-1.17.65-2.17,1.62-3s2.15-1.25,3.54-1.25,2.64.41,3.62,1.23c.98.82,1.52,1.83,1.63,3.02h-10.41Z"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 2, duration: 0.5 }}
              />
              <motion.path
                className="cls-3"
                d="M76.31,61.39c-1.06-.67-2.38-.61-3.47,0-.94.53-2.04.79-3.29.79-1.39,0-2.61-.39-3.64-1.16-1.03-.78-1.67-1.75-1.92-2.91h14.45c.07-1.08.1-1.65.1-1.72,0-2.63-.91-4.87-2.73-6.72-1.82-1.85-4.05-2.78-6.71-2.78s-4.83.93-6.67,2.8c-1.84,1.86-2.76,4.1-2.76,6.7s.99,4.92,2.77,6.7c1.9,1.89,4.26,2.84,7.1,2.84,1.55,0,3.06-.34,4.52-1.01,1.46-.67,2.63-1.58,3.5-2.73l-1.26-.79ZM65.6,51.87c.97-.83,2.15-1.25,3.54-1.25s2.64.41,3.62,1.23c.98.82,1.52,1.83,1.63,3.02h-10.41c.11-1.17.65-2.17,1.62-3Z"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 2.1, duration: 0.5 }}
              />
              <motion.path
                className="cls-3"
                d="M85.45,46.85c-.65,0-1.21.24-1.68.72-.47.48-.71,1.05-.71,1.7s.24,1.21.71,1.68,1.03.71,1.68.71,1.21-.24,1.69-.71c.45-.47.67-1.03.67-1.68s-.23-1.22-.69-1.7c-.46-.48-1.02-.72-1.67-.72Z"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 2.2, duration: 0.5 }}
              />
              <motion.path
                className="cls-3"
                d="M83.43,61.08c0,3.03-1.11,4.55-3.34,4.55h0c-.84,0-1.57.55-1.8,1.36l-.59,2.08c.81.36,1.79.54,2.93.54,2.04,0,3.69-.67,4.94-2.02,1.25-1.35,1.87-3.52,1.87-6.5v-7.73l-4.01,1.73v6Z"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 2.3, duration: 0.5 }}
              />
            </g>
            <motion.rect
              className="cls-3"
              x="101.69"
              width="1.04"
              height="71.35"
              initial={{ scaleY: 0, opacity: 0 }}
              animate={{ scaleY: 1, opacity: 1 }}
              transition={{
                delay: 0.5,
                duration: 1.2,
                ease: [0.22, 1, 0.36, 1],
              }}
              style={{ transformOrigin: "center" }}
            />
          </g>
        </g>
      </motion.svg>
    </motion.div>
  );
}
